import React from "react";

type RadioSwitchProps = Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  "type" | "name"
> & {
  name: string;
  label: string;
};

export const RadioSwitch = (props: RadioSwitchProps) => {
  const radioSwitchId = props.id || props.name;

  return (
    <div className="custom-control custom-switch">
      <input
        {...props}
        id={radioSwitchId}
        type="checkbox"
        className="custom-control-input"
        checked={props.checked || false}
        onChange={props.onChange}
        css={`
          .custom-control-input:checked ~ .custom-control-label::before {
            background-color: #007bff;
            border-color: #007bff;
          }
          .custom-control-input:focus ~ .custom-control-label::before {
            box-shadow: 0 0 0 1.8px #fff;
          }
          .custom-control-input:focus:not(:checked)
            ~ .custom-control-label::before {
            border-color: #80bdff;
          }
          .custom-control-input:not(:disabled):active
            ~ .custom-control-label::before {
            background-color: #b3d7ff;
            border-color: #b3d7ff;
          }
          .custom-control-input[disabled] ~ .custom-control-label,
          .custom-control-input:disabled ~ .custom-control-label {
            color: #6c757d;
          }
        `}
      />
      <label htmlFor={radioSwitchId} className="custom-control-label">
        {props.label}
      </label>
    </div>
  );
};
